function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Statistic, Button, Skeleton, Descriptions, Divider } from 'antd';
import { Table } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import Common from "../components/includes/Common";
import { PrinterFill, HouseFill } from "react-bootstrap-icons";
import { PersonFill, Cash, WalletFill, CreditCardFill, PeopleFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RpReports = function RpReports() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCustomerDataLoading = _useState4[0],
    setIsCustomerDataLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    customers = _useState6[0],
    setCustomers = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    rpCustomers = _useState8[0],
    setRpCustomers = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    monthCustomers = _useState0[0],
    setMonthCustomers = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    rpMonthCustomers = _useState10[0],
    setRpMonthCustomers = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    zonesDataLoading = _useState12[0],
    setZonesDataLoading = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    zonesData = _useState14[0],
    setZonesData = _useState14[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedCustomer = _useState16[0],
    setSelectedCustomer = _useState16[1];
  var handleReprint = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(c) {
      var cu;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setSelectedCustomer(c);
            _context.n = 1;
            return selectedCustomer;
          case 1:
            cu = _context.v;
            reprint();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleReprint(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var reprint = function reprint() {
    var content = document.getElementById("reprintid");
    var pri = document.getElementById("ifmcontentstoreprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };
  useEffect(function () {
    setIsDataLoading(true);
    console.log('User id ' + Common.currentUser.id);
    axios.get(Common.baseApiUrl + 'getrpcurrentdaycustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setRpCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getrpcurrentmonthcustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setRpMonthCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcurrentmonthcustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setMonthCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoreprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      id: "reprintid",
      children: selectedCustomer != null && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            width: '70px'
          },
          children: /*#__PURE__*/_jsx("img", {
            src: "drawables/mvc.jpeg",
            style: {
              width: '100%'
            }
          })
        }), /*#__PURE__*/_jsxs("h2", {
          children: ["RNC : ", selectedCustomer.rnc]
        }), /*#__PURE__*/_jsxs(Descriptions, {
          column: 1,
          children: [/*#__PURE__*/_jsx(Descriptions.Item, {
            label: "T\xE9l\xE9phone : ",
            children: selectedCustomer.mobile
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Nom :",
            children: selectedCustomer.firstname + ' ' + selectedCustomer.lastname
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "Montant : ",
            children: "200 000 GNF"
          }), /*#__PURE__*/_jsx(Descriptions.Item, {
            label: "M. Paiement : ",
            children: selectedCustomer.paymentmethod.label
          })]
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse: Conakry, Kip\xE9, Prima center. Tel: 611 72 49 21"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: "JOURNEE"
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total clients",
                        value: customers.length.toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(PersonFill, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total Encaissement (GNF)",
                        value: (customers.length * 120000).toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(Cash, {})
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "cool-radius",
                    style: {
                      background: '#FFDE08'
                    },
                    children: [/*#__PURE__*/_jsx(Statistic, {
                      title: "CASH (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 1;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(Cash, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "OM (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 2;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(WalletFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "TPE (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id == 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(CreditCardFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "SOCIETE (GNF)",
                      value: (customers.filter(function (customer) {
                        return customer.paymentmethod.id > 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(HouseFill, {})
                    })]
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: "JOURNEE RP"
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        size: "small",
                        title: "Total clients",
                        value: rpCustomers.length.toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(PersonFill, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        size: "small",
                        title: "Total Encaissement (GNF)",
                        value: (rpCustomers.length * 120000).toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(Cash, {})
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "cool-radius",
                    style: {
                      background: '#EA6A6B'
                    },
                    children: [/*#__PURE__*/_jsx(Statistic, {
                      title: "CASH (GNF)",
                      value: (rpCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 1;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(Cash, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "OM (GNF)",
                      value: (rpCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 2;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(WalletFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "TPE (GNF)",
                      value: (rpCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(CreditCardFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "SOCIETE (GNF)",
                      value: (rpCustomers.filter(function (customer) {
                        return customer.paymentmethod.id > 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(HouseFill, {})
                    })]
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: "MOIS"
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total clients",
                        value: monthCustomers.length.toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(PersonFill, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total Encaissement (GNF)",
                        value: (monthCustomers.length * 120000).toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(Cash, {})
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "cool-radius",
                    style: {
                      background: '#FFDE08'
                    },
                    children: [/*#__PURE__*/_jsx(Statistic, {
                      title: "CASH (GNF)",
                      value: (monthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 1;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(Cash, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "OM (GNF)",
                      value: (monthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 2;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(WalletFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "TPE (GNF)",
                      value: (monthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(CreditCardFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "SOCIETE (GNF)",
                      value: (monthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id > 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(HouseFill, {})
                    })]
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsxs(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: "MOIS RP"
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total clients",
                        value: rpMonthCustomers.length.toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(PersonFill, {})
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 12,
                      md: 12,
                      sm: 12,
                      children: /*#__PURE__*/_jsx(Statistic, {
                        title: "Total Encaissement (GNF)",
                        value: (rpMonthCustomers.length * 120000).toLocaleString('Fr'),
                        prefix: /*#__PURE__*/_jsx(Cash, {})
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  sm: 6,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "cool-radius",
                    style: {
                      background: '#EA6A6B'
                    },
                    children: [/*#__PURE__*/_jsx(Statistic, {
                      title: "CASH (GNF)",
                      value: (rpMonthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 1;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(Cash, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "OM (GNF)",
                      value: (rpMonthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 2;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(WalletFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "TPE (GNF)",
                      value: (rpMonthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id == 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(CreditCardFill, {})
                    }), /*#__PURE__*/_jsx(Statistic, {
                      title: "SOCIETE (GNF)",
                      value: (rpMonthCustomers.filter(function (customer) {
                        return customer.paymentmethod.id > 3;
                      }).length * 120000).toLocaleString('Fr'),
                      prefix: /*#__PURE__*/_jsx(HouseFill, {})
                    })]
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 9,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "LISTE DE LA JOURNEE"
            }), !isDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Table, {
                size: "sm",
                bordered: true,
                responsive: true,
                striped: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: "RNC"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Pr\xE9nom"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Nom"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "T\xE9l\xE9phone"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "M. paiement"
                    }), /*#__PURE__*/_jsx("th", {})]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: customers.map(function (c) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("th", {
                        children: c.rnc
                      }), /*#__PURE__*/_jsx("th", {
                        children: c.firstname
                      }), /*#__PURE__*/_jsx("th", {
                        children: c.lastname
                      }), /*#__PURE__*/_jsx("th", {
                        children: c.mobile
                      }), /*#__PURE__*/_jsx("th", {
                        children: c.paymentmethod.label
                      }), /*#__PURE__*/_jsx("th", {
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            handleReprint(c);
                          },
                          children: /*#__PURE__*/_jsx(PrinterFill, {
                            size: 22
                          })
                        })
                      })]
                    }, c.id);
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })]
      }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })]
  });
};
export default RpReports;